export const environment = {
  production: true,
  apiVersion: '1.15',
  version: ''
};
